import { createUseStyles } from 'react-jss';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { TextColors } from '@picsart/design-system/foundation/colors';

import { Breakpoints } from '@/lib/breakpoints';
import { HEADER_CONTROL_HEIGHT, iconPaint, focusRing } from '@/components/HeaderAuthSection/styleTokens';

const useStyles = createUseStyles(
  {
    /**
     * Shown only where the header's search field is not.
     *
     * `SearchDropdown` hides below `sm` because a field cannot share that row
     * with the logo and the auth cluster. Without this there was no way to
     * search on a phone at all: the field was gone and `/search` had no input of
     * its own, so the term could not be typed anywhere.
     */
    link: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      // Square, at the same height as the pills beside it, so the control strip
      // keeps one baseline.
      width: HEADER_CONTROL_HEIGHT,
      height: HEADER_CONTROL_HEIGHT,
      marginLeft: 'auto',
      borderRadius: CornerRadius.circle,
      color: TextColors.base,
      textDecoration: 'none',
      ...focusRing,
      [Breakpoints.SM]: { display: 'none' },
    },
    icon: { ...iconPaint, width: 20, height: 20 },
  },
  { name: 'header-search-link' },
);

export default useStyles;
